import { CookieClass } from '../../class/cookie.class'
import { TOPUP_COOKIE_BACK_URL_NAME } from '../../const/topup.const'

export default {
  created () {
    CookieClass.removeCookie(TOPUP_COOKIE_BACK_URL_NAME)
  }
}
